import { RouterStore } from '@avantstay/mobx-routing-utils'

import customHistory from '@utils/history'

// Constructing the store registers it inside @avantstay/mobx-routing-utils,
// so computedRouteParam consumers must import this module (via the
// computedRouteParam wrapper) before reading params.
export const RoutingStore = new RouterStore(customHistory)
